module.exports = __webpack_public_path__ + "static/media/BannerBackground.ac4a1ea6.png";